import UnitResources from './component';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import UnitResourcesNav from 'components/UnitResourcesNav';
import { getUnitList } from 'data/Units/accessors';

function getFirstUnitId(getState, groupId) {
  const unitList = getUnitList(getState(), groupId);
  const firstUnit = unitList && unitList.toList().first();
  return firstUnit && firstUnit.id;
}

export default ({ getState }) => ({
  appBars: {
    sticky: {
      navigation: {
        component: UnitResourcesNav,
        order: 1,
      },
    },
  },
  path: 'unit-resources(/:unitId)',
  component: UnitResources,
  canAccess: ({ params }) =>
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.UnitResources),
  tab: {
    label: 'Resources',
    order: 11,
    isVisible: (params) =>
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.UnitResources),
    params: (currentParams) => ({
      ...currentParams,
      unitId: getFirstUnitId(getState, currentParams.groupId),
    }),
  },
  breadcrumbLabels: () =>
    [{
      label: 'Resources',
      clickable: false,
    }],
});



// WEBPACK FOOTER //
// ./containers/Group/UnitResources/routes.js